/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';
import { keyEmptyCheck } from 'aurora-utils/utils';
import { ADGMImage } from 'aurora-components';

function NoPrimaryContact(props) {
  const { classes, handleModalOpen, profileMode } = props;

  return (
    <>
      {profileMode ? (
        <Box
          className={classes.NoPrimaryContactContainer}
          pt={5}
          mx='auto'
          display='flex'
          textAlign='center'
          justifyContent='center'
          alignItems='center'
          flexDirection='column'
        >
          <Box className={classes.phoneIcon} display='flex' justifyContent='center' alignItems='center'>
            <ADGMImage name='phoneIcon.svg' alt='phoneIcon' />
          </Box>
          <Box component={Typography} className={classes.NoPrimaryContactTitle} mt={2} mb={1} variant='h6'>
            {keyEmptyCheck('you_dont_have_any_primary_contacts_added')}
          </Box>
          <Box component={Typography} px={3} className={classes.textInfo}>
            {/*  eslint-disable-next-line  */}
            {keyEmptyCheck('add_primary_contact_hint', {
              s: <strong onClick={() => handleModalOpen()}>{keyEmptyCheck('click_here')}</strong>,
            })}
          </Box>
        </Box>
      ) : (
        <Box>
          <Box display='flex' alignItems='center' px={1} my={2} mx='auto' className={classes.infoMsg}>
            <ADGMImage name='Information.svg' alt='infoIcon' className={classes.infoIcon} />
            <Typography>
              {keyEmptyCheck('you_dont_have_any_primary_contacts_added')} {/*  eslint-disable-next-line  */}
              {keyEmptyCheck('add_primary_contact_hint', {
                s: (
                  <>
                    {/*  eslint-disable-next-line  */}
                    <br />{' '}
                    <strong onClick={() => handleModalOpen()}>
                      {keyEmptyCheck('click_here')}
                    </strong>
                  </>
                ),
              })}
            </Typography>
          </Box>
        </Box>
      )}
    </>
  );
}
NoPrimaryContact.propTypes = {
  classes: PropTypes.object.isRequired,
  handleModalOpen: PropTypes.func.isRequired,
  profileMode: PropTypes.bool.isRequired,
};

export default NoPrimaryContact;
